import angular from 'angular';
import { directive as ifMatchMedia } from './if.directive';
import { directive as classMatchMedia } from './class.directive';
import { QUERIES, matchMediaDirectiveName } from './match-media.utils';

export const MatchMediaModule = angular.module(
  'app.directives.match-media',
  []
);

createMatchMediaDirectives([ifMatchMedia, classMatchMedia]);

/**
 * Creates a version of each directive targeting each of our media queries.
 * by stitching together the directive's prefix-name with each query name.
 *
 *  E.g.:
 *    `upd-if-match-media-xs`
 *    `upd-if-match-media-sm`
 *    ...
 */
function createMatchMediaDirectives(directiveFns) {
  Object.keys(QUERIES).forEach(query => {
    directiveFns.forEach(directive => {
      MatchMediaModule.directive(
        matchMediaDirectiveName(directive.prefixName, query),
        directive(query)
      );
    });
  });
}
